<template>
  <div class="swiper_main">
     <swiper class="swiper"
     :options="swiperOption"
     :auto-update="true"
     :auto-destroy="true"
     >
      <swiper-slide  :key="index" v-for="(banner, index) in banners">
          <!-- <div class="swiper-zoom-container">

          </div> -->
          <img :src="banner" class="swiper-lazy">
          <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
  </div>
</template>

<script>
import webmms from "webmms-client";
import { set as setCookie, get as getCookie, remove as removeCookie } from "es-cookie";
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import conf from '@/config/config';

export default {
  name: 'Slider',
  props: ['pageParams'],
  data() {
    return {
      json: {},
      banners: [

       ],
      swiperOption: {
          spaceBetween: 10,
          centeredSlides: true,
          loop: true,
          lazy:true,
          autoplay: {
            delay: 200000,
            disableOnInteraction: false
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
      },
      eiInfo: {
          eiName: '',
          eiTag: '',
          ddn : ''
      },
       webmmsOptions : {
            EiToken: '',
            SToken: '',
            UToken: ''
      },
      error: true,
      timeout: 0,
      mmsReady: false,
      mms: null
    };
  },
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },

  async created() {
   this.readQueryParam();
  this.startMMS();
  },
  async beforeMount() {
     await this.subscribeMMS();
  },
  beforeDestroy() {
      this.removeEvent();
  },
  methods: {
     startMMS(){
          this.mms =  webmms({
            wsurl: conf.wsurl,
            EiToken: getCookie("slider-EiToken") || "",
            SToken: getCookie("slider-SToken") || ""
          });
      },
     readQueryParam(){
        let { json, src, loop, yp, mname, mtag } = this.pageParams;
         if(src) {
              fetch(src)
                .then(async res => {
                  const data = JSON.parse(await res.text());
                  this.json = Object.assign({},this.json, data);
                  console.log(this.json);
                })
                .catch(e => {
                  console.error(e.message);
                });
              return;
          }

          if(loop)
            this.swiperOption.loop = loop;

          if (json){
              try {
                console.log(this.pageParams)
                this.banners = JSON.parse(json);
              } catch (error) {
                this.banners = json;
              }

              this.banners.forEach((src,  index) => {
                 if(src == '{}')
                  this.banners.splice(index, 1);
              });
              return;
          }
    },
    async subscribeMMS() {
        this.removeEvent = this.mms.on("registered", async reply => {
            //console.log('reply=%s', JSON.stringify(reply))
             if(reply.ErrMsg == "OK"){
                this.eiInfo.ddn = reply.result.DDN;
                this.webmmsOptions.EiToken = reply.result.EiToken;
                this.webmmsOptions.SToken = reply.result.SToken;
                this.webmmsOptions.UToken = reply.result.UToken;
                if(this.eiInfo.eiName == ''){
                  this.eiInfo.eiName = reply.result.EiName ? reply.result.EiName : 'pgSLIDER' + this.makeId(5);
                }
                 if(this.eiInfo.eiTag == ''){
                  this.eiInfo.eiTag = reply.result.EiTag ? reply.result.EiTag : '';
                }
             }

             let expiredTime = 60 * 60 * 24 * 30 * 12;

             setCookie("slider-EiToken", this.webmmsOptions.EiToken);
             setCookie("slider-SToken", this.webmmsOptions.SToken);


             console.log('regtoCenter: %s', reply.ErrMsg);
             this.mmsReady = true;
             this.error = false;
             let deviceInfo = {"DDN":this.eiInfo.ddn,"EiOwner":"","EiName":this.eiInfo.eiName,"EiType":".page","EiTag":this.eiInfo.eiTag,"EiLoc":""};
             let result = await this.mms.setDeviceInfo(deviceInfo);
             console.log('SetDevice reply=%s', JSON.stringify(result));
             await this.track(this.mms, 'slider', this.pageParams);
        });

        this.mms.on('message', (method, from, data, retcb) => {
              this.mmsReady = true;
             this.error = false;
             console.log('rcve: from=%s, data=%s', from, JSON.stringify(data));
            if ( typeof retcb == 'function') retcb({"ErrCode":0, "ErrMsg":"OK"})
        });

        this.mms.on('state', msg => {
            console.log('WS error: %s', msg);
            this.mmsReady = false;
            this.error = true;
        });

        this.mms.on('disconnect', msg => {
            this.mmsReady = false;
            this.error = true;
        });

        this.mms.on('error', err => {
             this.mmsReady = false;
            this.error = true;
        });

        this.mms.on('connect_error', err => {
             this.mmsReady = false;
            this.error = true;
        });

        this.mms.on('connect_timeout', err => {
            this.mmsReady = false;
            this.error = true;
        });
      }
  }
};
</script>

<style lang="scss">
.swiper_main{
  height: 94vh;
  .swiper{
    height: 100%;
     .swiper-slide {
       text-align: center;
      background: #444;

       img {
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: 100%;
          transform: translate(-50%, -50%);
          position: absolute;
          left: 50%;
          top: 50%;
        }
    }
    .swiper-button-prev, .swiper-button-next{
      --swiper-theme-color: #e1e1e1;
    }
    .swiper-pagination-bullet-active{
      --swiper-theme-color: #e1e1e1;
    }
  }
}
</style>

